export default __webpack_public_path__ + "static/media/ps_13.938daedd.png";